import { render, staticRenderFns } from "./PedidoDeCompraConteudo.vue?vue&type=template&id=69459d94&scoped=true"
import script from "./PedidoDeCompraConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoDeCompraConteudo.vue?vue&type=style&index=0&id=69459d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69459d94",
  null
  
)

export default component.exports